import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Text } from '@machobear/design-system'
import { colors } from '@/styles'
import EmptyImage from './empty-applications-image'

type Props = {
  text: string
}

const ApplicationsEmptyListComponent: React.FC<Props> = ({ text }) => {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      style={{ minHeight: '60vh', backgroundColor: `${colors.white}` }}
    >
      <Box style={{ width: '350px' }} maxWidth="small" marginY="xxxlarge">
        <Stack align="center" space="large">
          <EmptyImage
            alt={text || t('b.contract.view.nothing_here.text', 'Nothing here for now...')}
          />
          <Stack align="center" space="medium">
            <Stack align="center" space="small">
              <Text size="medium" weight="medium">
                {t('l.application.table.empty.no_applications_found', 'No applications found.')}
              </Text>
              <Text align="center" size="small">
                {t(
                  'l.application.table.empty.try_adjusting_your_search',
                  'Try adjusting your search or try again.'
                )}
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Box>
  )
}

export default ApplicationsEmptyListComponent
